import axios from 'axios'
import { UserResponse } from '@/interfaces'

const baseUrl = '/api/Account'
export const accountClient = {
  getUserSession: () =>
    axios.get<UserResponse>(`${baseUrl}/CurrentUser`).then(x => x.data)
}
